<template>
    <div class="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4 sm:p-6 lg:p-8">
      <div class="bg-white p-4 sm:p-6 lg:p-8 rounded-lg shadow-lg w-full max-w-4xl">
        <h2 class="text-xl sm:text-2xl font-bold mb-4 sm:mb-6 text-gray-800">Orders</h2>
  
        <!-- Orders Table -->
        <div class="overflow-x-auto mt-4">
          <table class="min-w-full table-auto border-collapse">
            <thead>
              <tr class="bg-gray-200">
                <th class="p-2 sm:p-3 border text-left">Order Date</th>
                <th class="p-2 sm:p-3 border text-left">Total Value</th>
                <th class="p-2 sm:p-3 border text-left">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="order in this.userOrders" :key="order.id" class="bg-gray-50 hover:bg-gray-100">
                <td class="p-2 sm:p-3 border">{{ formatDate(order.createdAt) }}</td>
                <td class="p-2 sm:p-3 border">{{ formatCurrency(order.totalAmount) }}</td>
                <td class="p-2 sm:p-3 border flex justify-center space-x-2">
                  <!-- View Details Icon Button -->
                  <button @click="viewOrderDetails(order.id)"
                          class="text-blue-500 hover:text-blue-700 focus:outline-none">
                    <i class="fas fa-eye"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
  
        <!-- Order Details Modal -->
        <OrderDetailsModal v-if="isOrderModalOpen"
                           :isOpen="isOrderModalOpen"
                           :order="currentOrder"
                           @close="closeOrderModal" />
      </div>
    </div>
  </template>
  
  <script>

  import { mapActions,mapState } from 'vuex';
  import OrderDetailsModal from '../components/OrderDetailsModal.vue';

  
  export default {
    components: { OrderDetailsModal },
    data() {
      return {
        myOrders: [],
        isOrderModalOpen: false,
        currentOrder: null,
      };
    },
    async mounted() {
       await this.fetchOrders(2);
       console.log(this.userOrders)
    },
    computed : {
        ...mapState('orders', {
            userOrders: state => state.userOrders
        }),
    },
    methods: {
        ...mapActions('orders', {
          fetchOrders: 'fetchOrders',
        }),
      viewOrderDetails(orderId) {
        const order = this.userOrders.find(o => o.id === orderId);
        if (order) {
          this.currentOrder = order;
          this.isOrderModalOpen = true;
        }
      },
      closeOrderModal() {
        this.isOrderModalOpen = false;
        this.currentOrder = null;
      },
      formatDate(date) {
        return new Date(date).toLocaleDateString(); // Format date as needed
      },
      formatCurrency(value) {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'RwF' }).format(value);
      }
    }
  };
  </script>
  
  <style scoped>
  /* Optional: Add any custom styles here */
  </style>
  